import colors from '../constants/colors';

const setCssVariables = () => {
  const root = document.documentElement;

  Object.keys(colors).forEach((color) => {
    root.style.setProperty(`--${color}`, colors[color]);
  });
};

export default setCssVariables;
